<!-- <otui-card> -->
<div class="tile" [ngClass]="variant">
  <div class="filter">
    <ng-content></ng-content>
  </div>
</div>
<!-- </otui-card> -->
